import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Icon = _resolveComponent("Icon");
    return (_openBlock(), _createElementBlock("span", {
        class: _normalizeClass(["badge", [
                { 'text-capitalize': !_ctx.uncapitalize },
                { 'badge-pill': _ctx.pill || _ctx.canBeDeleted },
                { 'badge-can-be-deleted': _ctx.canBeDeleted },
                { [`badge-color-${_ctx.color}`]: _ctx.color }
            ]])
    }, [
        (_ctx.iconName)
            ? (_openBlock(), _createBlock(_component_Icon, {
                key: 0,
                class: "pre-icon",
                name: _ctx.iconName,
                title: _ctx.iconTitle
            }, null, 8, ["name", "title"]))
            : _createCommentVNode("", true),
        _createElementVNode("span", {
            class: _normalizeClass([{ 'w-75': _ctx.canBeDeleted }, "text-truncate"])
        }, _toDisplayString(_ctx.text), 3),
        (_ctx.canBeDeleted)
            ? (_openBlock(), _createBlock(_component_Icon, {
                key: 1,
                clickable: true,
                title: _ctx.tr('javascript.TX_DELETE'),
                name: "cross",
                onMousedown: _cache[0] || (_cache[0] = _withModifiers(($event) => (_ctx.$emit('delete', _ctx.text)), ["prevent"]))
            }, null, 8, ["title"]))
            : _createCommentVNode("", true)
    ], 2));
}
